<template src="./template.html"></template>

<script>
  import { clone } from 'lodash'
  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'EditProfile',
    data() {
      return {
        editedUser: {},
        dateFormatted: null,
        dateFormatError: false,
      }
    },
    computed: {
      ...mapState('users', ['user']),
      ...mapState('auth', ['settings']),
    },
    created() {
      this.editedUser = clone(this.user)
      this.dateFormatted = this.formatDate(this.editedUser.birthday)
    },
    methods: {
      checkDate(date) {
        this.dateFormatError = Boolean(date && !moment(
          this.formatDate(date),
          'DD/MM/YYYY',
          true,
        ).isValid())
        return !this.dateFormatError
      },
      formatDate(date) {
        if (!date) return null

        const splitDate = date.split('-').length === 3 ? date.split('-') :
          date.split('.').length === 3 ? date.split('.') :
            date.split('/').length === 3 ? date.split('/') : false

        if (splitDate) {
          let day
          let month
          let year

          if (5 > splitDate[0].length > 2 || splitDate[0] > 31) {
            [
              year,
              month,
              day,
            ] = splitDate
          } else {
            [
              day,
              month,
              year,
            ] = splitDate
          }
          if (year.length !== 3) {
            const fillYear = parseInt(moment().format('YYYY').substring(0, 3))
            year = year <= moment().format('YY') ? year.padStart(4, fillYear) : year.padStart(4, fillYear - 10)
          }
          return `${day.padStart(2, '0').substr(0, 2)}/${month.padStart(2, '0').substr(0, 2)}/${year.substr(0, 4)}`
        } else {
          return date
        }

      },
      parseDate(date) {
        if (!date) return null

        date = this.formatDate(date)

        let [
          day, //
          month,
          year,
        ] = date.split('/')
        if (year.length !== 3) {
          const fillYear = parseInt(moment().format('YYYY').substring(0, 3))
          year = year <= moment().format('YY') ? year.padStart(4, fillYear) : year.padStart(4, fillYear - 1)
        }
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      onSave() {
        if (this.checkDate(this.dateFormatted)) {
          this.editedUser.birthday = this.parseDate(this.formatDate(this.dateFormatted))
          this.$emit('onSave', {
            email: this.editedUser.email,
            birthday: this.editedUser.birthday,
            is_birth_year_visible: this.editedUser.is_birth_year_visible,
          })
        } else {
          return false
        }
      },
    },
  }
</script>
